module.exports = __webpack_public_path__ + "583d3da7549a06dff90663574e4bec18.svg";